import {Record} from 'immutable';
import moment from 'moment-timezone';

function fromAPI(data) {
    return new AgeGroup({
        ageGroupId: data.id,
        institutionId: data.institutionId,
        title: data.title,
        capacity: data.capacity,
        staffRatio: data.staffRatio,
        lower: data.lower,
        upper: data.upper,
        validFrom: moment(data.validFrom, 'YYYY-MM-DD'),
    });
}

export const AgeGroup = Record({
    capacity: 0,
    staffRatio: 0,
    ageGroupId: '',
    institutionId: '',
    lower: 0,
    title: '',
    upper: 0,
    validFrom: moment(),
});

export default {
    fromAPI,
    AgeGroup,
};
